/** Canonical application roles. It mirrors Prisma's Role enum. */
export const Roles = {
  SUPERADMIN: "SUPERADMIN",
  OWNER: "OWNER",
  ADMIN: "ADMIN",
  PROFESSIONAL: "PROFESSIONAL",
  RECEPTIONIST: "RECEPTIONIST",
  SECRETARY: "SECRETARY",
  PATIENT: "PATIENT",
} as const;

export type Role = (typeof Roles)[keyof typeof Roles];

export const ROLE_VALUES = Object.values(Roles) as [Role, ...Role[]];

/** Roles that can exist in a Staff membership. PATIENT is deliberately excluded. */
export const ASSIGNABLE_CLINIC_ROLES = [
  Roles.OWNER,
  Roles.ADMIN,
  Roles.PROFESSIONAL,
  Roles.RECEPTIONIST,
  Roles.SECRETARY,
] as const;

export type ClinicStaffRole = (typeof ASSIGNABLE_CLINIC_ROLES)[number];

/** Role groups used by invitation lists and counters. */
export const INVITATION_ROLE_GROUPS = {
  PATIENT: [Roles.PATIENT],
  PROFESSIONAL: [Roles.PROFESSIONAL],
  STAFF: [Roles.ADMIN, Roles.SECRETARY, Roles.RECEPTIONIST],
} as const;

export type InvitationRoleGroup = keyof typeof INVITATION_ROLE_GROUPS;

export function isRole(value: unknown): value is Role {
  return typeof value === "string" && ROLE_VALUES.includes(value as Role);
}
